/* eslint-disable */
import { Button, ButtonMode, ButtonSize } from '@creditsights/styleguide-web';
import React from 'react';
import { NavLink } from 'react-router-dom';
import { formatDate } from '../../../utils/date.utils';
import { hasMoreData } from '../../../utils/page.utils';

import './DocumentSearchResultsTable.scss';

function DocumentSearchResultsTable({ data, updateSort, reportType, pageSize, fetchNextPage, isFetchingNextPage }) {
  const renderCompany = (issuer, tags) => {
    const companyTag = tags.find((tag) => tag.startsWith('company/'));

    if (companyTag) {
      const companyId = companyTag.replace('company/', '');
      return <NavLink to={`/companies/${companyId}`}>{issuer}</NavLink>;
    } else {
      return <span>{issuer}</span>;
    }
  };

  const renderDocumentName = (docType, docName, url) => {
    if (docType === 'Research Report') {
      return <span></span>;
    } else {
      return (
        <a target="_blank" href={url}>
          <i className="file alternate outline icon"></i> {docName}
        </a>
      );
    }
  };

  const renderDocument = ({ docName, docType, docUrl, file }) => {
    if (docUrl) {
      return renderDocumentName(docType, docName, docUrl);
    } else if (file) {
      const splits = file.split('/');
      const url = splits
        .map((i, index) => {
          if (index === splits.length - 1) {
            return encodeURIComponent(i);
          } else {
            return i;
          }
        })
        .join('/');
      return renderDocumentName(docType, docName, `/api/common/v1/attachments/${url}`);
    }

    return <span></span>;
  };

  return (
    <div className="cs-body-search-results">
      <div className="table-ctx">
        <table className="ui table">
          <thead>
            <tr>
              <th className="sortable" onClick={() => updateSort('issuer')}>
                Issuer <i className="sort icon" />
              </th>
              <th className="sortable" onClick={() => updateSort('issue_name')}>
                Issue <i className="sort icon" />
              </th>
              {reportType !== 'reports' && (
                <th className="sortable" onClick={() => updateSort('docName')}>
                  Document <i className="sort icon" />
                </th>
              )}
              <th className="sortable" onClick={() => updateSort('issue_date')}>
                Issue Date <i className="sort icon" />
              </th>
              <th className="sortable" onClick={() => updateSort('maturity_date')}>
                Maturity Date <i className="sort icon" />
              </th>
            </tr>
          </thead>
          <tbody>
            {data.pages.map((page) =>
              page.results.map((row, index) => (
                <tr key={index}>
                  <td>{renderCompany(row.issuer, row.tags)}</td>
                  <td>
                    <NavLink to={`/articles/${row.id}`}>{row.issue_name}</NavLink>
                  </td>
                  {reportType !== 'reports' && <td>{renderDocument(row)}</td>}
                  <td className="nowrap">{formatDate(row.issue_date)}</td>
                  <td className="nowrap">{formatDate(row.maturity_date)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {hasMoreData(data, pageSize, data?.pages[0]?.totalResults) && (
          <div className="next-page">
            <Button mode={ButtonMode.PRIMARY} size={ButtonSize.MEDIUM} loading={isFetchingNextPage} disabled={isFetchingNextPage} onClick={() => fetchNextPage()}>
              Load {pageSize} more
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default DocumentSearchResultsTable;
